import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Input, Row } from 'reactstrap'
import DataTableWrapper from 'src/components/Grid/DataTableWrapper'
import { Columns, LazyTableState } from 'src/models/components/dataTableWrapperModel'
import avator from "../../assets/images/avatar.jpg"
import ColumnAction from 'src/components/Common/ColumnAction/ColumnAction'
import "./Ticketsystem.scss"
import FeatherIcon from "feather-icons-react";
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTER } from 'src/constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'src/store/reducers'
import { employeeDropdownForJobLoading, getEnquiryListPageLoading, getManufacturerDropdownTicketingSystemLoading, getTechnicianDropdownLoading, getTicketCreateCustomerDataLoading, jobDealerdropdownListLoading, reOpenTicketFromCustomerLoading } from 'src/store/actions'
import { DataTableFilterMeta } from 'primereact/datatable'
import { EnquiryItems } from 'src/models/pages/ticketSystemModel'
import { formatDateMEL, formatDateTimeForHistoryView, formatDateTimeMEL, formatUtcToIstForHistoryView, hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasFranchiseRoleHandler, hasManufacturerRoleHandler, onlyAdminRoleHandler, saveAsExcelFile } from 'src/helpers/common_helpers'
import FilterIcon from 'src/components/Common/CustomFilterandSortIcon/FilterIcon'
import SortIcon from 'src/components/Common/CustomFilterandSortIcon/SortIcon'
import { useToast } from 'src/components/Common/ReactToaster'
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup'
import ExportFile from 'src/components/Common/ExcelPdf Export/ExportFile'
import TooltipMEL from 'src/components/UI/Tooltip'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel'
import { API } from 'src/util/api'
import { use } from 'echarts'
import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { set } from 'lodash'


const ticketListConverson = (values: EnquiryItems[]) => {
  const modifeidValue = values.map((eachValue) => {
    let data: any = {};
    data['id'] = eachValue?.id;
    data['subject'] = eachValue?.subject;
    data['description'] = eachValue?.description;
    data['Categorie'] = eachValue?.category;
    // data['follow'] = eachValue?.id;
    data['priority'] = eachValue?.priority;
    data['status'] = eachValue?.status;
    data['supporterName'] = eachValue?.supporterName;
    data['assignedTo'] = eachValue?.supporterName;
    data['creationTime'] = eachValue?.creationTime;
    data['createdBy'] = eachValue?.creatorName;
    data['dueDate'] = eachValue?.dueDate;
    data['completedDate'] = eachValue?.completedDate;
    data['isCompletedWithinDueDate'] = eachValue?.isCompletedWithinDueDate;
    data['number'] = eachValue?.number;
    data['tatDays'] = eachValue?.tatDays;
    data['unreadNotificationCount'] = eachValue?.unreadNotificationCount;

    return data;
  });
  return modifeidValue;
};

const TicketSystemListPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const priorityParam = searchParams.get('priority');
  const isCompletedWithinDueDateParam = searchParams.get('isCompletedWithinDueDate');
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const { enquiryList, error, loading, totalCount, message, tickerCreaters, manufacturerList } = useSelector((state: RootReducerState) => state.ticketSystemReducer);
  const [pdfLoading, setPdfLoading] = useState<boolean>(false)
  const { dealerList, technicianList, employeeList } = useSelector((state: RootReducerState) => state.jobsheetReducer);
  const { profile } = useSelector((state: RootReducerState) => state.profilesReducer);

  const modifiedValues: any[] = ticketListConverson(enquiryList);
  const [selectedStatus, setselectedStatus] = useState("ALL");

  const franchiseOptions = useMemo(() => {
    let options = technicianList?.map((item: any) => ({
      label: item.franchiseName,
      value: item.userId
    }))
    return options;
  }, [technicianList])

  const dealerOptions = useMemo(() => {
    let options = dealerList?.map((item: any) => ({
      label: item.name,
      value: item.userId
    }))
    return options;
  }, [dealerList])

  const employeeOptions = useMemo(() => {
    let options = employeeList?.map((item: any) => ({
      label: item.name,
      value: item.userId
    }))
    return options;
  }, [employeeList])

  const manufacturerOptions = useMemo(() => {
    let options = manufacturerList?.map((item: any) => ({
      label: item.name,
      value: item.userId
    }))
    return options;
  }, [manufacturerList])
  console.log("isCompletedWithinDueDateParam", isCompletedWithinDueDateParam)
  console.log("isCompletedWithinDueDateParam", typeof isCompletedWithinDueDateParam)
  const filterDetails: DataTableFilterMeta = {
    SupplierId: { value: "", matchMode: "contains" },
    PoNumber: { value: "", matchMode: "contains" },
    generatedDate: { value: "", matchMode: "contains" },
    GeneratedStartDate: { value: "", matchMode: "contains" },
    GeneratedEndDate: { value: "", matchMode: "contains" },
    BuyingCurrency: { value: "", matchMode: "contains" },
    Locked: { value: null, matchMode: "contains" },
    status: { value: null, matchMode: "contains" },
    creationTime: { value: "", matchMode: "contains" },
    CreationTimeTimeStartDate: { value: "", matchMode: "contains" },
    CreationTimeTimeEndDate: { value: "", matchMode: "contains" },
    dueDate: { value: "", matchMode: "contains" },
    DueDateStartDate: { value: "", matchMode: "contains" },
    DueDateEndDate: { value: "", matchMode: "contains" },
    completedDate: { value: "", matchMode: "contains" },
    CompletedStartDate: { value: "", matchMode: "contains" },
    CompletedEndDate: { value: "", matchMode: "contains" },
    IsDeleted: { value: "false", matchMode: "contains" },
    CustomerId: { value: "", matchMode: "contains" },
    supporterId: { value: JSON.parse(localStorage.getItem('authUser') || "{}")?.uid, matchMode: "contains" },
    assignedTo: { value: "", matchMode: "contains" },
    creatorId: { value: "", matchMode: "contains" },
    Categorie: { value: "", matchMode: "contains" },
    isAdmin: { value: (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true), matchMode: "contains" },
    priority: { value: priorityParam || "", matchMode: "contains" },
    AssignedTo: { value: (hasAdminOrEmployeeRoleHandler()) ? "" : JSON.parse(localStorage.getItem('authUser') || "{}")?.uid, matchMode: "contains" },
    isCompletedWithinDueDate: { value: isCompletedWithinDueDateParam === 'false' ? false : null, matchMode: "equals" },
  };
  const [currentUserId, setCurrentUserId] = useState("");
  const [creatorId, setCreatorId] = useState("");
  const [userType, setUserType] = useState("");
  const [statusCounts, setStatusCounts] = useState<any[]>([]);

  useEffect(() => {
    API.getTicketStatusCountApi((profile?.extraProperties?.IsAdmin || profile?.extraProperties?.IsSuperAdmin) ? true : false).then((res: any) => {
      if (Array.isArray(res)) setStatusCounts(res);
      else if (res && Array.isArray(res.data)) setStatusCounts(res.data);
      else if (res && Array.isArray(res.items)) setStatusCounts(res.items);
    }).catch(err => console.error(err));
  }, [profile]);

  const allRoles = hasCustomerRoleHandler() || hasFranchiseRoleHandler() || hasManufacturerRoleHandler()

  useEffect(() => {
    let data: any = localStorage.getItem('authUser')
    let parsed = JSON.parse(data)
    setCurrentUserId(parsed.uid)
  }, [])

  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };
  const [lazyState, setLazyState] = useState(initialLazyState);

  useEffect(() => {
    const currentPriorityValue = (lazyState.filters?.priority as any)?.value;
    const currentCompletedValue = (lazyState.filters?.isCompletedWithinDueDate as any)?.value;
    const newCompletedValue = isCompletedWithinDueDateParam === 'false' ? "false" : null;

    if ((priorityParam !== null && priorityParam !== currentPriorityValue) || (currentCompletedValue !== newCompletedValue)) {
      setLazyState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          ...(priorityParam !== null ? { priority: { value: priorityParam, matchMode: "contains" } } : {}),
          isCompletedWithinDueDate: { value: newCompletedValue, matchMode: "equals" }
        }
      }));
    }
  }, [priorityParam, isCompletedWithinDueDateParam]);

  const handleEdit = (rowData: any) => {
    if (currentUserId && rowData.unreadNotificationCount > 0) {
      API.markAsReadTicketNotificationApi(rowData.id, currentUserId)
    }
    navigate(ROUTER.EDIT_TICKET_SYSTEM + '/' + rowData.id)
  }

  const handleView = (rowData: any) => {
    if (currentUserId && rowData.unreadNotificationCount > 0) {
      API.markAsReadTicketNotificationApi(rowData.id, currentUserId)
    }
    navigate(ROUTER.VIEW_TICKET_SYSTEM + '/' + rowData.id)
  }

  const notificationTemplate = (rowData: any) => {
    return (
      <div
        style={{ cursor: 'pointer', position: 'relative', display: 'inline-block' }}
        onClick={() => handleView(rowData)}
      >
        <FeatherIcon icon="bell" size="18" />
        {rowData.unreadNotificationCount > 0 && (
          <span
            className="badge rounded-pill bg-danger"
            style={{
              position: 'absolute',
              top: '-8px',
              right: '-10px',
              fontSize: '10px',
              padding: '2px 5px'
            }}
          >
            {rowData.unreadNotificationCount}
          </span>
        )}
      </div>
    );
  };

  const reOpenTicketHandle = (id: any) => {

    dispatch(reOpenTicketFromCustomerLoading(id))

    if (allRoles) {
      if (currentUserId) {
        let lazy = {
          ...lazyState,
          filters: {
            ...lazyState.filters,
            supporterId: { value: currentUserId, matchMode: "contains" },
          },
        }
        dispatch(getEnquiryListPageLoading(lazy));
      }
    } else {
      dispatch(getEnquiryListPageLoading(lazyState));
    }
  }
  const actionBodyTemplate = (rowData: any, value: string) => {
    const displayData = rowData[value] ? (rowData[value] as string) : <div className="empty-number-jobeheet"><span></span><span></span><span></span></div>;
    if (rowData.status != "Closed") {
      return (
        <ColumnAction
          displayData={displayData}
          isEdit={true}
          onEditClick={() => handleEdit(rowData)}
          isView={true}
          onViewClick={() => handleView(rowData)}
        />

      )
    } else {
      return (
        <ColumnAction
          displayData={displayData}
          isView={true}
          isReopen={allRoles ? true : false}
          reopenClick={() => reOpenTicketHandle(rowData.id)}
          onViewClick={() => handleView(rowData)}
        />

      )
    }
  }

  const completedWithinDueDateTemplate = (rowData: any) => {
    if (rowData.isCompletedWithinDueDate === null) return "";
    return rowData.isCompletedWithinDueDate ? (
      <i className="mdi mdi-thumb-up text-success fs-4" title="Completed within due date"></i>
    ) : (
      <i className="mdi mdi-thumb-down text-danger fs-4" title="Not completed within due date"></i>
    );
  };

  const stateTemplate = (rowData: any, value: any) => {
    return (
      <div className='status'>
        <span className={rowData.state ? 'statusHighlight' : ""}>{rowData.state}</span>
      </div>
    )
  }

  const priorityTemplate = (rowData: any, value: any) => {
    return (
      <div>
        {
          (rowData.priority == "Medium" || rowData.priority == "medium") ? <span className="MediumStatus">{rowData.priority}</span> : (rowData.priority == "High" || rowData.priority == "high") ? <span className="highStatus">{rowData.priority}</span> : rowData.priority == "urgent" ? <span className="urgentStatus">{rowData.priority}</span> : <span className="low">{rowData.priority}</span>
        }
      </div>
    )
  }

  const statusTemplate = (rowData: any) => {
    return (
      <div>
        {
          rowData.status == "New" ? <span className="open">{rowData.status}</span> : rowData.status == "pending" ? <span className="pending">{rowData.status}</span> : rowData.status == "resolved" ? <span className="resolve">{rowData.status}</span> : rowData.status == "Reopen" ? <span className="reopen">{rowData.status}</span> : rowData.status == "Reassign" ? <span className="reassign">{rowData.status}</span> : rowData?.status == "Resolved" ? <span className="stclose">{rowData.status}</span> : <span className="stclose">{rowData.status}</span>
        }
      </div>
    )
  }

  const statusFilterElement = (options: any) => {
    return (<>
      <Dropdown
        options={[
          { label: 'New', value: 'New' },
          { label: 'Reassign', value: 'Reassign' },
          { label: 'Reopen', value: 'Reopen' },
          { label: 'Resolved', value: 'Resolved' },
          { label: 'Closed', value: 'Closed' },
        ]}
        name="buyingCurrency"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index);
          return {};
        }}
        required={true}
        value={options.value}
        filter itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.label}
          </div>
        )}
      />
    </>);
  }

  const priorityFilterElement = (options: any) => {
    return (<>
      <Dropdown
        options={[
          { label: 'High', value: 'high' },
          { label: 'Medium', value: 'medium' },
          { label: 'Low', value: 'low' },
        ]}
        name="buyingCurrency"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index);
          return {};
        }}
        required={true}
        value={options.value}
        filter itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.label}
          </div>
        )}
      />
    </>);
  }

  const assignedFilterElement = (options: any) => {
    return (<>
      <label htmlFor="">User Type</label>
      <Dropdown
        value={options?.value?.userType}
        options={[
          { label: 'Employee', value: 'Employee' },
          { label: 'Franchise', value: 'Franchise' },
          { label: 'Supplier', value: 'Supplier' },
        ]}
        onChange={(e: DropdownChangeEvent) => {
          let modifiedValue: any = options.value || { userType: "", userId: null };
          modifiedValue['userType'] = e.value;
          modifiedValue['userId'] = null; // Reset user when type changes
          options.filterCallback(modifiedValue, options.index);
        }}
        placeholder="Select User Type"
        className="p-column-filter mb-2"
      />
      <br />
      <label htmlFor="">User</label>
      <Dropdown
        options={options?.value?.userType === 'Employee' ? employeeOptions : options?.value?.userType === 'Supplier' ? manufacturerOptions : options?.value?.userType === 'Franchise' ? franchiseOptions : []}
        name="assignedTo"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => {
          let modifiedValue: any = options.value || { userType: "", userId: null };
          modifiedValue['userId'] = e.value;
          options.filterCallback(modifiedValue, options.index);
        }}
        value={options?.value?.userId}
        placeholder="Select User"
        className="p-column-filter"
        disabled={!options?.value?.userType}
        filter
        itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.label}
          </div>
        )}
      />
    </>);
  }

  const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (<>
      <label htmlFor="">Start Date</label>
      <Input type="date"
        required
        name={options?.value?.startDate}
        value={options?.value?.startDate || ""}
        max={options?.value?.endDate ? options?.value?.endDate : ""}
        onChange={(e: any) => {
          options;
          let modifiedDate: any = options.value || { startDate: "", endDate: "" };
          modifiedDate['startDate'] = e.target.value;
          options.filterCallback(modifiedDate, options.index);
        }}
      />
      <br />
      <label htmlFor="">End Date</label>
      <Input type="date"
        required
        name={options?.value?.endDate}
        value={options?.value?.endDate || ""}
        min={options?.value?.startDate ? options?.value?.startDate : ""}
        onChange={(e: any) => {
          options;
          let modifiedDate: any = options.value || { startDate: "", endDate: "" };
          modifiedDate['endDate'] = e.target.value;
          options.filterCallback(modifiedDate, options.index);
        }}
      />
    </>);
  };

  const categoryFilterElement = (options: any) => {
    return (<>
      <Dropdown
        options={[
          { label: "General query", value: "General query" },
          { label: "Email Response Delay", value: "Email Response Delay" },
          { label: "Reverse Pick Up", value: "Reverse Pick Up" },
          { label: "Chat Response Delay", value: "Chat Response Delay" },
          { label: "Part Dispatch Delay", value: "Part Dispatch Delay" },
          { label: "Leave Request", value: "Leave Request" },
          { label: "Permission Request", value: "Permission Request" },
          { label: "Purchase Order", value: "Purchase Order" },
          { label: "Task", value: "Task" },
          { label: "No Response", value: "No Response" },
        ]}
        name="buyingCurrency"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index);
          return {};
        }}
        required={true}
        value={options.value}
        filter itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.label}
          </div>
        )}
      />
    </>);
  }

  const columns: Columns[] = [
    {
      field: "number",
      sortable: true,
      header: "Number",
      filter: false,
      showFilterMenu: false,
      frozen: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
      body: (rowData) => actionBodyTemplate(rowData, "number"),
    },
    {
      field: "unreadNotificationCount",
      header: "Notifications",
      sortable: false,
      filter: false,
      showFilterMenu: false,
      body: (rowData) => notificationTemplate(rowData),
      headerStyle: { width: "100px", textAlign: 'center' },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "Categorie",
      sortable: false,
      header: "Category",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
      filterElement: categoryFilterElement
    },
    {
      field: "subject",
      sortable: true,
      header: "Subject",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "description",
      sortable: true,
      header: "Description",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "priority",
      sortable: true,
      header: "Priority",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      body: (rowData) => priorityTemplate(rowData, "priority"),
      isStatic: true,
      filterElement: priorityFilterElement
    },
    {
      field: "status",
      sortable: true,
      header: "Status",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      body: (rowData) => statusTemplate(rowData),
      isStatic: true,
      filterElement: statusFilterElement
    },
    {
      field: "creationTime",
      sortable: false,
      header: "Created On",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "200px" },
      body: (rowData) => formatDateTimeMEL(rowData.creationTime),
      isDefault: true,
      isStatic: true,
      filterElement: dateFilterTemplate
    },
    {
      field: "dueDate",
      sortable: false,
      header: "Due Date",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "200px" },
      body: (rowData) => rowData.dueDate ? formatDateTimeMEL(rowData.dueDate) : "",
      isDefault: true,
      isStatic: true,
      filterElement: dateFilterTemplate
    },
    {
      field: "completedDate",
      sortable: false,
      header: "Completed Date",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "200px" },
      body: (rowData) => rowData.completedDate ? formatDateTimeMEL(rowData.completedDate) : "",
      isDefault: true,
      isStatic: true,
      filterElement: dateFilterTemplate
    },
    {
      field: "isCompletedWithinDueDate",
      sortable: false,
      header: "Completed On Time Status",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "100px" },
      body: (rowData) => completedWithinDueDateTemplate(rowData),
      isDefault: true,
      isStatic: true,
    },
    {
      field: "createdBy",
      sortable: false,
      header: "Created By",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "assignedTo",
      sortable: false,
      header: "Assigned To",
      filter: hasAdminOrEmployeeRoleHandler() ? true : false,
      showFilterMenu: hasAdminOrEmployeeRoleHandler() ? true : false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
      filterElement: hasAdminOrEmployeeRoleHandler() ? assignedFilterElement : undefined
    },
    {
      field: "tatDays",
      sortable: true,
      header: "TAT",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "150px" },
      body: (rowData) => (rowData.tatDays || rowData.tatDays === 0) ? `${rowData.tatDays} Days` : "",
      isDefault: true,
      isStatic: true,
    },
  ];

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading || pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading, pdfLoading]);

  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (error) {
      setVisible(true)
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
      if (allRoles) {
        if (currentUserId) {
          let lazy = {
            ...lazyState,
            filters: {
              ...lazyState.filters,
              supporterId: { value: currentUserId, matchMode: "contains" },
            },
          }
          dispatch(getEnquiryListPageLoading(lazy));
        }
      } else {
        dispatch(getEnquiryListPageLoading(lazyState));
      }
    }
  }, [error, message])

  // useEffect(() => {
  //   dispatch(getEnquiryListPageLoading(lazyState))
  // }, [])

  const onCreateClickHandler = () => {
    navigate(ROUTER.CREATE_TICKET_SYSTEM);
  };

  const onPage = (event: any) => {
    setLazyState(event);
  };

  const onSort = (event: any) => {

    setLazyState(event);
  };

  const onFilter = (event: any) => {
    debugger
    event["first"] = 0;
    event['filters']['CreationTimeTimeStartDate']['value'] = event?.filters?.creationTime?.value?.startDate ? event?.filters?.creationTime?.value?.startDate : '';
    event['filters']['CreationTimeTimeEndDate']['value'] = event?.filters?.creationTime?.value?.endDate ? event?.filters?.creationTime?.value?.endDate : '';
    event['filters']['DueDateStartDate']['value'] = event?.filters?.dueDate?.value?.startDate ? event?.filters?.dueDate?.value?.startDate : '';
    event['filters']['DueDateEndDate']['value'] = event?.filters?.dueDate?.value?.endDate ? event?.filters?.dueDate?.value?.endDate : '';
    event['filters']['CompletedStartDate']['value'] = event?.filters?.completedDate?.value?.startDate ? event?.filters?.completedDate?.value?.startDate : '';
    event['filters']['CompletedEndDate']['value'] = event?.filters?.completedDate?.value?.endDate ? event?.filters?.completedDate?.value?.endDate : '';
    event['filters']['AssignedTo']['value'] = event?.filters?.assignedTo?.value?.userId ? event?.filters?.assignedTo?.value?.userId : ((profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true) ? "" : JSON.parse(localStorage.getItem('authUser') || "{}")?.uid);

    if (lazyState.filters?.isCompletedWithinDueDate) {
      event['filters']['isCompletedWithinDueDate'] = lazyState.filters.isCompletedWithinDueDate;
    }

    setLazyState(event);
  };

  const callbackFunction = (lazyState: LazyTableState) => {
    let currentStatus = (lazyState.filters?.status as any)?.value;
    let isClosedVal = currentStatus === 'Closed' ? true : false;
    let statusVal = currentStatus === 'Closed' ? "" : currentStatus;

    let commonLazyState = {
      ...lazyState,
      filters: {
        ...lazyState.filters,
        isAdmin: { value: (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true) ? true : "false" },
        supporterId: { value: currentUserId },
        creationTime: { value: "", matchMode: "contains" },
        dueDate: { value: "", matchMode: "contains" },
        completedDate: { value: "", matchMode: "contains" },
        assignedTo: { value: "", matchMode: "contains" },
        status: { value: statusVal || "", matchMode: "contains" },
        IsClosed: { value: isClosedVal, matchMode: "contains" }
      }
    };

    if (allRoles) {
      let lazy = {
        ...commonLazyState,
        filters: {
          ...commonLazyState.filters,
        },
      }
      dispatch(getEnquiryListPageLoading(lazy));
    } else {
      dispatch(getEnquiryListPageLoading(commonLazyState));
    }
  };

  useEffect(() => {
    callbackFunction(lazyState);
    dispatch(getTicketCreateCustomerDataLoading())
  }, [lazyState, currentUserId, profile]);

  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((val) => {
      let data: any = {}
      data['Number'] = val.number;
      data['Subject'] = val.subject;
      data['Category'] = val.Categorie;
      data['Description'] = val.description;
      data['Priority'] = val?.priority;
      data['Status'] = val?.status;
      data['Created On'] = formatDateTimeMEL(val?.creationTime);
      data['Due Date'] = val?.dueDate ? formatDateTimeMEL(val?.dueDate) : "";
      data['Completed Date'] = val?.completedDate ? formatDateTimeMEL(val?.completedDate) : "";
      data['SLA Status'] = val?.isCompletedWithinDueDate === true ? "Within Due Date" : val?.isCompletedWithinDueDate === false ? "Exceeded Due Date" : "";
      data['Assigned To'] = val?.assignedTo;
      data['TAT'] = (val?.tatDays || val?.tatDays === 0) ? `${val.tatDays} Days` : "";
      // data['Created By'] = val?.createdBy;
      return data;
    })
    return modifiedColumnDetails
  }

  const saveDataAsExcel = (values: any[], fileName: string) => {
    let modifiedColumnDetails = changeColumnDetails(values)
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    // let modifiedColumnDetails = changeColumnDetails(values)
    const destructureedData = values.map((data) => {
      let datas = {
        number: data.number,
        Categorie: data.Categorie,
        subject: data.subject,
        description: data.description,
        priority: data?.priority,
        status: data?.status,
        creationTime: formatDateTimeMEL(data?.creationTime),
        dueDate: data?.dueDate ? formatDateTimeMEL(data?.dueDate) : "",
        completedDate: data?.completedDate ? formatDateTimeMEL(data?.completedDate) : "",
        isCompletedWithinDueDate: data?.isCompletedWithinDueDate === true ? "Within Due Date" : data?.isCompletedWithinDueDate === false ? "Exceeded Due Date" : "",
        createdBy: data?.createdBy,
        assignedTo: data?.assignedTo,
        tatDays: (data?.tatDays || data?.tatDays === 0) ? `${data.tatDays} Days` : "",
      }
      return datas
    })
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
          styles: {
            cellPadding: 2,
            halign: 'center',
          },
          columnStyles: {
            address: { cellWidth: "40px" },
          },
        }));
        const doc = new (jsPDF as any).default({
          orientation: 'landscape',
          format: 'a3',
        });
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };

  const fetchData = async (isPdf: boolean) => {
    let lazy;
    if (currentUserId) {
      lazy = {
        ...lazyState,
        rows: totalCount > 5000 ? 5000 : totalCount < 1 ? 1 : totalCount,
        first: 0,
        filters: {
          ...lazyState.filters,
          supporterId: { value: currentUserId, matchMode: "contains" },
          isAdmin: { value: (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true), matchMode: "contains" },
        },
      }

    }

    try {
      setPdfLoading(true)
      const response = await API.getEnquiryListApi(lazy);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const modifeidValue = response?.data?.items?.map((eachValue: any) => {
        let data: any = {};
        data['id'] = eachValue?.id;
        data['subject'] = eachValue?.subject;
        data['description'] = eachValue?.description;
        data['Categorie'] = eachValue?.category;
        // data['follow'] = eachValue?.id;
        data['priority'] = eachValue?.priority;
        data['status'] = eachValue?.status;
        data['creationTime'] = eachValue?.creationTime;
        data['createdBy'] = eachValue?.creatorName;
        data['dueDate'] = eachValue?.dueDate;
        data['completedDate'] = eachValue?.completedDate;
        data['isCompletedWithinDueDate'] = eachValue?.isCompletedWithinDueDate;
        data['number'] = eachValue?.number;
        data['tatDays'] = eachValue?.tatDays;
        data['assignedTo'] = eachValue?.supporterName;

        return data;
      });
      // let resp=await ticketListConverson(response?.data?.items)
      if (isPdf) {

        saveDataAsPdf(modifeidValue, columns, "Ticket_System");
      } else {
        saveDataAsExcel(modifeidValue, "Ticket_System");
      }
      setPdfLoading(false)
    } catch (error: any) {
      showToast(error.message, { type: "error" })
      setPdfLoading(false)

    } finally {
      setPdfLoading(false)
    }
  };
  const csvClickHandler = () => {
    // saveDataAsExcel(modifiedValues, "Ticket_System");
    fetchData(false)
  };

  const pdfClickHandler = () => {
    // saveDataAsPdf(modifiedValues, columns, "Ticket_System");
    fetchData(true)
  };
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);

    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        customerId: { value: formValue, matchMode: "contains" },
      },
    }));
    setIsTooltipVisible(false)
  };
  const [customerName, setCustomerName] = useState("")
  const userOptions: any = tickerCreaters?.map((item: any) => ({
    label: item.name,
    value: item.userId
  })).sort((a: any, b: any) => {
    const labelA = a.label.toUpperCase().trim();
    const labelB = b.label.toUpperCase().trim();
    if (labelA < labelB) {
      return -1;
    }
    if (labelA > labelB) {
      return 1;
    }
    return 0;
  })
  const calendarRef = useRef<any>(null);
  const clearCustomCalendar = (e: any) => {
    calendarRef.current.toggle(e)
    setCreatorId("")
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        creatorId: { value: "", matchMode: "contains" },
      },
    }));
    setCustomerName("")
  }

  const searchCustomCalendar = (event: any) => {
    calendarRef.current.toggle(event)
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        creatorId: { value: creatorId, matchMode: "contains" },
      },
    }));
    if (creatorId) {
      let customername = userOptions?.find((item: any) => item.value == creatorId)?.label
      setCustomerName(customername)
    }
  }
  const clearFilter = () => {
    setSearchParams({});
    if (!allRoles) {
      setCreatorId("")
      setLazyState((state) => ({
        ...initialLazyState,
        filters: {
          ...initialLazyState?.filters,
          supporterId: { value: currentUserId, matchMode: "contains" },
          creatorId: { value: "", matchMode: "contains" },
          priority: { value: "", matchMode: "contains" },
        },
      }));
      setCustomerName("")
      setUserType("")
    }
    else {
      setLazyState({
        ...initialLazyState,
        filters: {
          ...initialLazyState.filters,
          priority: { value: "", matchMode: "contains" }
        }
      })
    }
  }


  useEffect(() => {
    if (hasAdminOrEmployeeRoleHandler()) {
      dispatch(jobDealerdropdownListLoading())
      dispatch(getTechnicianDropdownLoading())
      dispatch(getManufacturerDropdownTicketingSystemLoading())
      dispatch(employeeDropdownForJobLoading())
    }
  }, [])

  const header =
    <div className="table-header-container">
      <div className="label_margin">
        Ticketing System
      </div>
      {
        hasAdminOrEmployeeRoleHandler() &&

        <div id="calendar" className="calendar_btns" style={{ marginLeft: "10px" }}>
          <div className="table-header-container-item">
            <div className="btn-group">
              <button
                className="btn btn-soft-primary waves-effect waves-light"
                // onClick={toggleCalendar}
                onClick={(e) => calendarRef.current.toggle(e)}
              >
                {/* <i className="bx bx-calendar font-size-16 align-middle"></i> */}
                <FeatherIcon icon="search" style={{ Width: "6px" }} />
              </button>
            </div>
          </div>
        </div>
      }

      {statusCounts && statusCounts.length > 0 && (
        <div style={{ display: 'flex', gap: '8px', marginLeft: '15px', alignItems: 'center' }}>
          {statusCounts.filter((st: any) => st.status?.toLowerCase() !== 'total' && st.status?.toLowerCase() !== 'assign').map((st: any, idx: number) => {
            let badgeClass = "badge rounded-pill";
            switch (st.status?.toLowerCase()) {
              case 'new': badgeClass += " bg-success"; break;
              case 'closed': badgeClass += " bg-danger"; break;
              case 'reassign': badgeClass += " bg-warning"; break;
              case 'reopen': badgeClass += " bg-info"; break;
              case 'resolved': badgeClass += " bg-secondary"; break;
              case 'assign': badgeClass += " bg-primary"; break;
              default: badgeClass += " bg-primary"; break;
            }
            const currentStatusFilter = (lazyState.filters?.status as any)?.value;
            const isSelected = currentStatusFilter === st.status;
            return (
              <span
                key={idx}
                className={badgeClass}
                style={{
                  fontSize: '12px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  opacity: (currentStatusFilter && !isSelected) ? 0.5 : 1,
                  boxShadow: isSelected ? '0 0 0 2px #495057' : 'none'
                }}
                onClick={() => {
                  setLazyState((prev) => ({
                    ...prev,
                    filters: {
                      ...prev.filters,
                      status: { value: isSelected ? null : st.status, matchMode: "contains" }
                    }
                  }));
                }}
              >
                {st.status}: {st.count}
              </span>
            )
          })}
          <span
            className="badge rounded-pill"
            style={{
              fontSize: '12px',
              padding: '5px 10px',
              cursor: 'pointer',
              backgroundColor: '#6f42c1',
              color: 'white',
              opacity: (lazyState.filters?.status as any)?.value ? 0.5 : 1,
              boxShadow: !(lazyState.filters?.status as any)?.value ? '0 0 0 2px #495057' : 'none'
            }}
            onClick={() => {
              setLazyState((prev) => ({
                ...prev,
                filters: {
                  ...prev.filters,
                  status: { value: null, matchMode: "contains" }
                }
              }));
            }}
          >
            Total: {statusCounts.find((st: any) => st.status?.toLowerCase() === 'total')?.count ?? statusCounts.reduce((acc: number, curr: any) => acc + (curr.count || 0), 0)}
          </span>
        </div>
      )}
      <OverlayPanel ref={calendarRef} style={{ width: "200px" }}>

        <div className="mb-3">
          <label htmlFor="">Select User Type</label>
          <Dropdown value={userType} onChange={(e) => setUserType(e.value)} options={[
            { label: 'Employee', value: 'Employee' },
            { label: 'Customer', value: 'Customer' },
            { label: 'Dealer', value: 'Dealer' },
            { label: 'Franchise', value: 'Franchise' },
            { label: 'Supplier', value: 'Supplier' }
          ]} optionLabel="label" placeholder="Select User Type"
            filter className="w-full md:w-14rem" />
        </div>

        <div className="mb-3">
          <label htmlFor="">Select User</label>
          <Dropdown value={creatorId} onChange={(e) => setCreatorId(e.value)} disabled={!userType} options={userType == "Employee" ? employeeOptions : userType == "Customer" ? userOptions : userType == "Dealer" ? dealerOptions : userType == "Supplier " ? manufacturerOptions : franchiseOptions} optionLabel="label" placeholder="Select Customer"
            filter className="w-full md:w-14rem" />
        </div>


        <div className="p-column-filter-buttonbar">
          <button aria-label="Clear" className="p-button p-component p-button-outlined p-button-sm" type="button" onClick={clearCustomCalendar}>
            <span className="p-button-label p-c">Clear</span>
          </button>
          <button aria-label="Apply" className="p-button p-component p-button-sm" type="button" onClick={searchCustomCalendar}>
            <span className="p-button-label p-c">Apply</span>
          </button>
        </div>
      </OverlayPanel>
      {hasAdminOrEmployeeRoleHandler() && currentUserId &&
        <div className="table-header-container-item table-header-container-item-special">
          <b style={{ marginLeft: "10px" }}>{customerName}</b>
        </div>
      }
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item export_btns">
        <div style={{ display: "flex" }}>

          <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={true} />
        </div>

        {
          ((allRoles || hasAdminOrEmployeeRoleHandler())) && <div className="reponsive_positio">
            <Button type="button" className="btn btn-primary" onClick={onCreateClickHandler}>
              <FeatherIcon icon="plus-circle" className={"feathet-icon"} />
              Create Ticket
            </Button>
          </div>
        }

      </div>
    </div>;


  const hidePopup = () => {
    setVisible(false);
    // dispatch(ReserEmployeeDetails());
  }

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content" id="ticket-system">
        {visible && dialogContainer(error)}
        <DataTableWrapper
          header={header}
          filterIcon={FilterIcon}
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          columnDetails={columns}
          value={modifiedValues}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          // filterDisplay="row"
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalCount}
          // loading={loading}
          emptyMessage="No details found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Ticketing System  {last} records of {totalRecords} in total"
          // selection={selectedUsers}
          // onSelectionChange={onSelectionChange}
          // selectAll={selectAll}
          // onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        >
        </DataTableWrapper>
      </div>
    </React.Fragment>
  )
}

export default TicketSystemListPage